import {Form, InputGroup} from "react-bootstrap";
import {useState} from "react";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import traceStore from "../../../traceStore.ts";


export const TraceFilter = () => {

    const [selectedHttpMethod, setSelectedHttpMethod] = useState('ALL');
    const [selectedStatus, setSelectedStatus] = useState('All');


    function handleHttpMethodChanged(_: any, newValue: string){

        if (newValue !== null) {
            setSelectedHttpMethod(newValue);
            traceStore.filterHttpMethod = newValue;
        }

    }

    function handleStatusChanged (_: any, newValue: string) {

        if (newValue !== null) {
            setSelectedStatus(newValue);
            traceStore.filterStatus = newValue;
        }
    }

    function handleSearch(searchValue: string){

        console.log(searchValue)

        if (searchValue.length > 0) {
            traceStore.filterSearch = searchValue;
        }

    }

    return (
        <>
            <div className="d-flex align-items-center px-3 pt-3">
                <InputGroup className="d-flex flex-nowrap w-50 ps-1">
                    <InputGroup.Text className="input-group-text text-muted">
                        <i className="fe fe-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                        type="search"
                        placeholder="Search"
                        className="me-2 w-100"
                        aria-label="Search"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();   // optional—prevents form submit
                                handleSearch(e.currentTarget.value);
                            }
                        }}
                   />
                </InputGroup>
                <div className="d-flex pe-2 px-3 ms-auto">
                    <ToggleButtonGroup
                        color="primary"
                        value={selectedHttpMethod}
                        exclusive
                        onChange={handleHttpMethodChanged}
                        aria-label="HTTP Command"
                    >
                        <ToggleButton size="small" value="ALL">ALL</ToggleButton>
                        <ToggleButton size="small" value="GET">GET</ToggleButton>
                        <ToggleButton size="small" value="POST">POST</ToggleButton>
                        <ToggleButton size="small" value="PUT">PUT</ToggleButton>
                        <ToggleButton size="small" value="DELETE">DEL</ToggleButton>
                    </ToggleButtonGroup>
                    <span className="px-2" />
                    <ToggleButtonGroup
                        color="primary"
                        value={selectedStatus}
                        exclusive
                        onChange={handleStatusChanged}
                        aria-label="Status"
                    >
                        <ToggleButton size="small" value="All">ALL</ToggleButton>
                        <ToggleButton size="small" value="Success">SUCCESS</ToggleButton>
                        <ToggleButton size="small" value="Failed">FAILED</ToggleButton>
                    </ToggleButtonGroup>

                </div>
            </div>
        </>
    );
};


